import React, { useEffect, useState } from "react";
import displayINRCurrency from "../helpers/displayCurrency";
import UploadProduct from "../components/UploadProduct";
import { MdDelete, MdEdit } from "react-icons/md";
import { motion } from "framer-motion";

const AllProducts = () => {

  const [products, setProducts] = useState([]);
  const [openUpload, setOpenUpload] = useState(false);
  const [editData, setEditData] = useState(null);

  /* 🔥 FETCH */
  const fetchProducts = async () => {
    try {
      const res = await fetch("https://lappyshop.onrender.com/api/get-product");
      const data = await res.json();

      if (data.success) {
        setProducts(data.data);
      }
    } catch (err) {
      console.log("Fetch error", err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  /* 🔥 DELETE */
  const deleteProduct = async (id) => {
    if (!window.confirm("Delete product?")) return;

    try {
      const res = await fetch("https://lappyshop.onrender.com/api/delete-product", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ productId: id }),
      });

      const data = await res.json();

      if (data.success) {
        fetchProducts();
      } else {
        alert("Delete failed");
      }

    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="p-4 bg-gray-50 min-h-screen">

      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">

        <h1 className="text-3xl font-bold">
          Inventory Management
        </h1>

        <button
          onClick={() => setOpenUpload(true)}
          className="bg-blue-600 text-white px-5 py-2 rounded-lg shadow hover:bg-blue-700"
        >
          + Add Product
        </button>

      </div>

      {/* GRID */}
      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">

        {products.map((product, i) => {

          const totalStock = product?.variants?.reduce(
            (a, b) => a + (b.stock || 0), 0
          ) || 0;

          const price = product?.variants?.[0]?.price || 0;

          return (
            <motion.div
              key={product._id}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.05 }}
              className="bg-white rounded-2xl shadow hover:shadow-xl transition p-4 group"
            >

              {/* IMAGE */}
              <div className="h-40 flex items-center justify-center overflow-hidden">
                <img
                  src={product.productImage?.[0]}
                  className="h-full object-contain group-hover:scale-110 transition"
                />
              </div>

              {/* DETAILS */}
              <h2 className="font-semibold mt-3 line-clamp-1">
                {product.productName}
              </h2>

              <p className="text-sm text-gray-500 capitalize">
                {product.brand}
              </p>

              <p className="text-blue-600 font-bold text-lg mt-1">
                {displayINRCurrency(price)}
              </p>

              <p className="text-sm text-gray-600">
                Stock: {totalStock}
              </p>

              {/* VARIANTS */}
              <div className="mt-2 text-xs space-y-1 max-h-16 overflow-y-auto">
                {product?.variants?.map((v, i) => (
                  <p key={i}>
                    {v.ram} / {v.storage} → {displayINRCurrency(v.price || 0)}
                  </p>
                ))}
              </div>

              {/* ACTIONS */}
              <div className="flex justify-end gap-3 mt-4 opacity-0 group-hover:opacity-100 transition">

                <button
                  onClick={() => setEditData(product)}
                  className="p-2 bg-blue-100 text-blue-600 rounded-full hover:bg-blue-200"
                >
                  <MdEdit />
                </button>

                <button
                  onClick={() => deleteProduct(product._id)}
                  className="p-2 bg-red-100 text-red-600 rounded-full hover:bg-red-200"
                >
                  <MdDelete />
                </button>

              </div>

            </motion.div>
          );
        })}

      </div>

      {/* ADD PRODUCT */}
      {openUpload && (
        <UploadProduct
          onClose={() => setOpenUpload(false)}
          fetchData={fetchProducts}
        />
      )}

      {/* EDIT PRODUCT */}
      {editData && (
        <UploadProduct
          productData={editData}
          onClose={() => setEditData(null)}
          fetchData={fetchProducts}
        />
      )}

    </div>
  );
};

export default AllProducts;